module.exports = __webpack_public_path__ + "img/bp_tier2.ebea07f0.png";